import type { User } from '@/hooks/v1/types/User'
import { isWeb3WithdrawalAvailable } from './withdrawalAvailability.ts'

type Web3User = Pick<User, 'native_asset_id' | 'is_web3_enabled'>
type NativeAsset = { id: string; symbol?: string }

export const isWeb3DepositAvailable = (
  user: Web3User | undefined,
  assets: Array<NativeAsset>,
): boolean => user?.is_web3_enabled === true && isWeb3WithdrawalAvailable(user, assets)
